import { getAccessContext } from '@/services/accessContext'
import { canRevokeApproval } from '@/utils/accessPolicy'

/*
 * 一覧（業務報告・勤務表・経費精算・通勤費精算・休暇申請）の［承認取消］（束5、2026-09-30）。
 *
 * ■ ボタンは押せる人にだけ出す
 *
 * 前は状態（承認済み）だけを見て出していた。事務担当者にはボタンが出るのに、
 * 押すと「現在の契約プランまたは権限グループでは…」と断られていた。
 * 判定は back の経路表と同じもの（accessPolicy.canRevokeApproval）を使う。
 * 権限の文脈が取れるまでは出さない（出してから消えるより、遅れて出るほうがよい）。
 *
 * ■ 取り消したあとどうなるかを、押す前に言う
 *
 * 承認取消は状態を「承認待ち」に戻すだけで、承認者は変わらない。本人は
 * 承認待ちのままでは直せないので、何をすれば直せるかまで書く。
 * 本人が［自分の申請一覧］の［申請取消］で未申請に戻せる（承認者が差し戻しても直せる）。
 */
// 文は 2026-10-09 に決めた。
export const REVOCATION_AFTERWARDS =
  '承認を取り消すとステータスが「承認待ち」に戻り、前と同じ承認者の「承認待ちの申請」に再度表示されます。' +
  '本人が内容を修正するには、「自分の申請一覧」で［申請取消］を行うか、承認者が［差戻し］をする必要があります。'

/** 確認の文。先頭の問い（誰の・いつの・何の承認か）は各一覧の文をそのまま使う。 */
export function revocationConfirmMessage (question) {
  return `${question}\n\n${REVOCATION_AFTERWARDS}`
}

export default {
  data () {
    return {
      revocationAccessContext: null
    }
  },

  computed: {
    canRevokeApproval () {
      return canRevokeApproval(this.revocationAccessContext)
    }
  },

  created () {
    let request = null
    try {
      request = getAccessContext()
    } catch (error) {
      request = null
    }
    if (!request || typeof request.then !== 'function') return
    request
      .then(context => { this.revocationAccessContext = context })
      .catch(() => { this.revocationAccessContext = null })
  },

  methods: {
    revocationConfirmMessage
  }
}
